import { makeStyles } from "tss-react/mui";

interface IParams {
    topOffset?: number;
}

export const useStyle = makeStyles<IParams>()((theme, props) => ({
    dialogAlignTop: {
        "& .MuiDialog-container": {
            alignItems: "flex-start",
        },
        "& .MuiDialog-paper": {
            marginTop: props.topOffset,
        },
    },
    dialogClose: {
        position: "absolute",
    },
    dialogCloseIcon: {
        "& button": {
            margin: theme.spacing(0.875),
        },
    },
}));
